import React from 'react';
import { Popover, Paper, Checkbox, ListItemText } from '@material-ui/core';

const ColumnsPopover = ({ open = false, anchorPosition = null, onClose, value = [], options = [], onChange, iconColor = '#6200EE' }) => {
  const safeValue = Array.isArray(value) ? value : [];

  const isSelected = (item) => safeValue.some((selectedItem) => selectedItem?.field === item?.field);

  const handleToggle = (item, event) => {
    event.preventDefault();
    event.stopPropagation();

    const exists = isSelected(item);

    const newValue = exists ? safeValue.filter((selectedItem) => selectedItem?.field !== item?.field) : [...safeValue, item];

    onChange({
      target: {
        value: newValue,
      },
    });
  };

  return (
    <Popover
      open={open}
      onClose={onClose}
      anchorReference="anchorPosition"
      anchorPosition={anchorPosition || { top: 0, left: 0 }}
      disableAutoFocus
      disableEnforceFocus
      disableRestoreFocus
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      PaperProps={{
        style: {
          maxHeight: 400,
          minWidth: 240,
          overflowY: 'auto',
          padding: '8px 0',
        },
      }}
    >
      <Paper elevation={0}>
        {options.map((item, index) => {
          const checked = isSelected(item);

          return (
            <div
              key={`${item.field || item.title}-${index}`}
              onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
              onClick={(e) => handleToggle(item, e)}
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: '8px 16px',
                cursor: 'pointer',
                userSelect: 'none',
              }}
            >
              <Checkbox checked={checked} style={{ color: iconColor }} tabIndex={-1} disableRipple />
              <ListItemText primary={item.title} />
            </div>
          );
        })}
      </Paper>
    </Popover>
  );
};

export default ColumnsPopover;
